import { render, staticRenderFns } from "./WorkNavigation.vue?vue&type=template&id=c067d3aa&"
import script from "./WorkNavigation.vue?vue&type=script&lang=js&"
export * from "./WorkNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports